import { Component } from 'react'

class HomeEvent extends Component {}

export default HomeEvent
